import React, { useState, useRef, useEffect } from 'react';
import { FiChevronDown, FiCheck } from 'react-icons/fi';

const MultiSelectQueues = ({ queues, selected, onChange, placeholder = 'كل الكيوهات' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const toggle = (q) => {
    if (selected.includes(q)) onChange(selected.filter(x => x !== q));
    else onChange([...selected, q]);
  };

  const label = selected.length === 0 ? placeholder : selected.length === 1 ? selected[0] : `${selected.length} كيوهات مختارة`;

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="filter-select"
        style={{ cursor: 'pointer', textAlign: 'right', minWidth: 160, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}
      >
        <FiChevronDown size={14} />
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</span>
      </button>
      {open && (
        <div style={{
          position: 'absolute', top: '100%', right: 0, marginTop: 4,
          background: '#fff', border: '1px solid #ddd', borderRadius: 6,
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 1000,
          minWidth: 220, maxHeight: 280, overflowY: 'auto'
        }}>
          {selected.length > 0 && (
            <div style={{ padding: '8px 12px', borderBottom: '1px solid #eee' }}>
              <button
                type="button"
                onClick={() => onChange([])}
                style={{ background: 'none', border: 'none', color: '#dc2626', cursor: 'pointer', fontSize: 12, fontFamily: 'inherit' }}
              >
                مسح الكل
              </button>
            </div>
          )}
          {queues.map(q => {
            const isSelected = selected.includes(q);
            return (
              <div
                key={q}
                onClick={() => toggle(q)}
                style={{
                  padding: '10px 12px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  background: isSelected ? '#eff6ff' : '#fff',
                  fontSize: 13
                }}
                onMouseEnter={e => !isSelected && (e.currentTarget.style.background = '#f9fafb')}
                onMouseLeave={e => !isSelected && (e.currentTarget.style.background = '#fff')}
              >
                <div style={{
                  width: 18, height: 18, border: '2px solid ' + (isSelected ? '#3b82f6' : '#ccc'),
                  borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: isSelected ? '#3b82f6' : '#fff'
                }}>
                  {isSelected && <FiCheck size={12} color="#fff" />}
                </div>
                <span>{q}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MultiSelectQueues;
